import { twMerge } from 'tailwind-merge';
import { type CustomArrowProps } from 'react-slick';

const arrowClass =
  'absolute top-1/2 -translate-y-1/2 z-[4] border-0 bg-transparent cursor-pointer transition-colors hover:text-primary [&.slick-next]:right-[-10px] [&.slick-prev]:left-[-10px] [&.slick-disabled]:opacity-30 [&.slick-disabled]:cursor-default';

export const NextArrow = ({ className, onClick, style }: CustomArrowProps) => (
  <button className={twMerge(arrowClass, className)} onClick={onClick} style={style} type="button">
    <span className="material-symbols-outlined">chevron_right</span>
    <span className="sr-only">Next slide</span>
  </button>
);

export const PrevArrow = ({ className, onClick, style }: CustomArrowProps) => (
  <button className={twMerge(arrowClass, className)} onClick={onClick} style={style} type="button">
    <span className="material-symbols-outlined">chevron_left</span>
    <span className="sr-only">Previous slide</span>
  </button>
);
